export enum BmarkFixingEventOperation {
  ADD, // BmarkFixingData
  REMOVE, // BmarkFixingData
  MOVE_TO_RECENT, // fixingId
  MOVE_TO_ACTIVE, // fixingId
  UPDATE_DATA, // BmarkFixingData
  UPDATE_ACTIVE_LIST, // Array<BmarkFixingData>
  UPDATE_RECENT_LIST, // Array<BmarkFixingData>
}

export namespace BmarkFixingEventOperation {
  let elements = [
    BmarkFixingEventOperation.ADD,
    BmarkFixingEventOperation.REMOVE,
    BmarkFixingEventOperation.MOVE_TO_RECENT,
    BmarkFixingEventOperation.MOVE_TO_ACTIVE,
    BmarkFixingEventOperation.UPDATE_DATA,
    BmarkFixingEventOperation.UPDATE_ACTIVE_LIST,
    BmarkFixingEventOperation.UPDATE_RECENT_LIST,
  ];
  let alias = "com.bcdfx.model.BmarkFixingOperation";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
